export default "__VITE_ASSET__DVh07Nte__"